export default __webpack_public_path__ + "static/media/thumbnail_funnel_1.9b26ab5c.png";